import axios from '../config'
import { TTS_api } from '../baseURL'

export default {
  TTS(text, type = 1002, speed = 0) {
    return axios.post(`${TTS_api}/textToVoice`, {
      Text: text,
      VoiceType: type,
      Speed: speed,
    }).then(ret => {
      if (ret.data && ret.data.Audio) return 'data:audio/mp3;base64,' + ret.data.Audio
      return ''
    })
  },

  getTXCloudInfo(token) {
    return axios.get(`${TTS_api}/getTXCloudInfo?token=${token}`)
  },
}